import { signal } from "@preact/signals-react";

const _disabled = signal(true);

import Button from "./Button";

function ButtonTable({ model, record, field, data, triggerAction }) {
  const { name, readOnly, method, button_method, style } = field;
  // if (!visible(name, record)) return null;

  const label = `${model}.${name}`;
  _disabled.value = readOnly;
  function onClick(event) {
    event.stopPropagation();
    event.preventDefault();
    const method_action = button_method ?? method;
    triggerAction(record, method_action);
  }

  const color = field.color || "grey";
  return (
    <Button
      key={data.value}
      size={style || "w-full"}
      height="h-8"
      iconRight={field.iconRight}
      iconLeft={field.iconLeft}
      onClick={(event) => onClick(event)}
      color={color}
      content={label}
      disabled={_disabled}
    />
  );
}

export default ButtonTable;
